import {
    Card,
    InlineStack,
    Icon,
    Tabs,
    Text,
    BlockStack,
    Box,
    RadioButton,
    Bleed,
    Divider
} from '@shopify/polaris';
import React, { useCallback, useState, useEffect, ReactElement } from 'react';
import { DI, DIProps } from '../../../../Core';
import { getAmazonRegion, myTabs } from './utils/utils';
import '../css/styles.css';
import { DropdownMinor } from '@shopify/polaris-icons';
import { ProductLinkingProvider } from './utils/context/context';
import { useTranslation } from 'react-i18next';
import '../css/styles.css';
interface Props extends DIProps {
    syncNecessaryInfo: () => void;
    syncConnectorInfo: () => void;
}
/**
 * This component is responsible for the Product Linking structure
 * @param props
 * @returns
 */
function ProductLinkings(props: Props): ReactElement {
    const { t } = useTranslation();
    const [clicks, setClicks] = useState<number>(0);
    const [fulfillmentType, setFulfillmentType] = useState<string>('FBM');
    const [loader, setLoader] = useState<any>(true);
    const [viewSku, setViewSku] = useState("");
    const [viewTab, setViewTab] = useState<any>(null);
    const [listingCount, setListingCount] = useState({ close_matched: 0, not_linked: 0, linked: 0, deleted: 0 });
    const tabs = myTabs(loader, listingCount, viewTab, viewSku);

    const sourceData = props.redux?.current?.source;
    const targetData = props.redux?.current?.target;

    const necessaryDetails = {
        'source': {
            'shopId': sourceData?._id, // shopify shop id
            'marketplace': sourceData?.marketplace // shopify
        },
        'target': {
            'shopId': targetData?._id, // amazon shop id
            'marketplace': targetData?.marketplace // amazon
        },
    }

    const getSelectedTab = (props: any): number => {
        let tab: number = 0;

        // Use URLSearchParams for cleaner extraction
        const searchParams = new URLSearchParams(props.location?.search);
        const tabParam = searchParams.get("tab");

        if (tabParam !== null && !isNaN(parseInt(tabParam))) {
            const parsedTab = parseInt(tabParam);
            if (parsedTab >= 0 && parsedTab <= 2) {
                return parsedTab;
            }
        }

        // Fallback to params if query param is invalid or not present
        if (
            props.match?.params?.tab !== undefined &&
            !isNaN(parseInt(props.match.params.tab))
        ) {
            const parsedTab = parseInt(props.match.params.tab);
            if (parsedTab >= 0 && parsedTab <= 2) {
                return parsedTab;
            }
        }

        return tab; // Default to 0 if no valid tab found
    };


    // const [selected, setSelected] = useState(props.location.search !== "" && props.location.search.split("=")[1] !== ""
    //     && parseInt(props.location.search.split("=")[1]) >= 0 && parseInt(props.location.search.split("=")[1]) <= 2 ?
    //     parseInt(props.location.search.split("=")[1]) : 0);

    const [selected, setSelected] = useState(getSelectedTab(props));

    const handleTabChange = useCallback((selectedTabIndex: number) => {
        setSelected(selectedTabIndex);
        setViewSku("");
        setViewTab(null);
    }, []);

    useEffect(() => {
        if (props?.location?.state?.from == "transferOrder") {
            if (props?.location?.state?.to == 'closedMatch') {
                setSelected(0)
            }
            if (props?.location?.state?.to == 'linkingRequired') {
                setSelected(1)
            }
        }
    }, [props?.location?.state]);

    useEffect(() => { getListingCount() }, []);

    const getListingCount = async (selectedTab = "all") => {
        await props.di.POST(`amazon/product/getMatchStatusCount`, {
            ...necessaryDetails, 'fulfillment-channel': fulfillmentType
        }).then(val => {
            setLoader(false)
            if (val.success && val.data) {
                delete val.data?.[selectedTab];
                renderListingCount({ ...val.data });
            } else {
                // props.error(t(val.message) ?? t("Request unsuccessful"));
            }
        })
    }

    const renderListingCount = (data: any) => {
        setListingCount((prevState) => ({ ...prevState, ...data }))
    }

    const viewProductValue = (tab: number, text: string) => {
        setViewSku(text);
        setSelected(tab);
        setViewTab(tab);
    }

    const viewOnShopify = (containerId: string) => {
        const shopifyUrl = sourceData?.['myshopify_domain'] ? "http://" + sourceData?.['myshopify_domain'] + "/admin/products/" + containerId : "";
        return shopifyUrl;
    }

    const viewOnAmazon = (asin: string) => {
        const amazonRegion = getAmazonRegion(targetData['warehouses']?.[0]?.['marketplace_id'], "marketplace_id");
        const amazonUrl = amazonRegion ? "http://" + amazonRegion?.url + "/dp/" + asin : "";
        return amazonUrl;
    }

    const handleFulfillmentChange = (type: 'FBA' | 'FBM') => {
        // setClicks((prev) => prev + 1);
        setFulfillmentType(type);
    }

    return (
        <div className='custom-productlinking card-box-shadow'>
            <ProductLinkingProvider value={{
                renderListingCount,
                getListingCount,
                viewProductValue,
                necessaryDetails,
                viewOnShopify,
                viewOnAmazon,
                fulfillmentType,
            }}>
                <BlockStack gap='400'>
                    {/* <InlineStack gap='400'>
                        <Text as='p' fontWeight={'semibold'}>Fulfilment Type: </Text>
                        <div onClick={handleFulfillmentChange} style={{ cursor: 'pointer' }}>
                            <InlineStack gap='100'>
                                <Text as='p' fontWeight={'semibold'}>{t(fulfillmentType)}</Text>
                                <Icon source={DropdownMinor} accessibilityLabel={fulfillmentType}></Icon>
                            </InlineStack>
                        </div>
                    </InlineStack> */}
                    <Card padding='0' roundedAbove='sm'>
                        <BlockStack gap="400">
                            <Box paddingBlockStart="400" paddingInlineStart="400">
                                <InlineStack gap="500" blockAlign='center'>
                                    <Text variant="headingSm" as="h6">{t("Fulfilment Type:")}</Text>
                                    <InlineStack gap="200">
                                        <RadioButton
                                            label={t("Fulfilment by Merchant (FBM)")}
                                            id="fbm"
                                            name="fulfilment_type"
                                            checked={fulfillmentType === 'FBM'}
                                            onChange={() => handleFulfillmentChange('FBM')}
                                        />
                                        <RadioButton
                                            label={t("Fulfilment by Amazon (FBA)")}
                                            checked={fulfillmentType === 'FBA'}
                                            id="fba"
                                            name="fulfilment_type"
                                            onChange={() => handleFulfillmentChange('FBA')}
                                        />
                                    </InlineStack>
                                </InlineStack>
                            </Box>
                            <Bleed marginInline="0">
                                <Divider />
                            </Bleed>
                            <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange} />
                            <Bleed marginInline="0">
                                <Divider />
                            </Bleed>
                            <Box paddingInline="400" paddingBlockStart="0" paddingBlockEnd="400">
                                {tabs[selected].TabContent}
                            </Box>
                        </BlockStack>
                    </Card>
                </BlockStack>
            </ProductLinkingProvider>
        </div >
    );
}
export default DI(ProductLinkings);